module.exports = __webpack_public_path__ + "img/Frame 5142.d03b49d7.jpg";